var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEye = function SvgIconEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M11.317 12.961a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M22.267 12.442c-1.068 1.575-4.55 5.92-10.446 5.92s-9.378-4.345-10.446-5.92a.99.99 0 0 1 0-1.122C2.443 9.745 5.925 5.4 11.82 5.4s9.378 4.345 10.446 5.92a.99.99 0 0 1 0 1.122m-5.19-.561a5.04 5.04 0 1 1-10.08 0 5.04 5.04 0 0 1 10.08 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconEye;